export const landingCallMessages = {
  en: {
    landing_secure_video_calls: "Secure video calls",
    landing_enter_room: "Enter a Room",
    landing_join_room_action: "Join room",
    landing_create_room_action: "Create room",
    landing_enter_room_code: "Enter room code",
    landing_try_again: "Try again",
    landing_room_code_helper: "Enter all 6 letters to continue.",
    landing_room_code_invalid_character: "Room codes use only A-Z and 0-9",
    landing_checking_room: "Checking…",
    landing_checking_room_hint: "Checking whether this room is already active.",
    landing_room_found_hint: "Room found. You can join it now.",
    landing_room_not_found_create_hint: "Room not found. You can create it with this code.",
    landing_token_required_hint: "This room code is unused.",
    landing_enter_token_prompt_action: "Enter token to create rooms",
    landing_enter_token_hint: "Enter your token to create new rooms",
    landing_recent: "Recent",
    landing_edit_label: "Edit label",
    landing_delete_room: "Delete room",
    landing_save_label: "Save label",
    landing_change_token: "Change Token",
    landing_enter_new_token_placeholder: "Enter new token",
    landing_cancel: "Cancel",
    landing_save: "Save",
    landing_token_set: "Token set",
    landing_host_admin_access_active: "Host admin access active",
    landing_budget_admin_access_active: "Budget admin access active",
    landing_change_token_action: "Change token",
    landing_clear_token: "Clear token",
    landing_admin: "Admin",
    landing_created_room: "Created room: {roomId}",
    landing_invalid_token: "Invalid token",
    landing_token_saved: "Token saved",
    landing_service_entitlement_verifying: "Verifying…",
    landing_service_entitlement_verifying_hint:
      "Checking this service entitlement before enabling room creation",
    landing_service_entitlement_saved_exhausted:
      "Service entitlement saved, but its budget is exhausted",
    landing_service_entitlement_exhausted_hint:
      "This service entitlement is saved, but its budget is exhausted. Update it to create new rooms.",
    landing_room_check_failed: "Could not check room availability",
    landing_room_unavailable: "Room is no longer available",
    call_room: "room",
    call_copy_room_code: "Copy room code",
    call_click_to_copy: "Click to copy",
    call_room_code_copied: "Room code copied",
    call_room_code_copy_failed: "Could not copy room code",
    call_desktop_side_by_side: "Side by side",
    call_desktop_focus_remote: "Focus remote",
    call_mobile_picture_in_picture: "Picture in picture",
    call_mobile_remote_only: "Remote only",
    call_you: "You",
    call_remote: "Remote",
    call_muted_badge: "Muted",
    call_waiting_for_participant: "Waiting for participant...",
    call_connection_interrupted: "Connection interrupted",
    call_participant_disconnected: "Participant disconnected",
    call_participant_camera_off: "Participant camera off",
    call_takeover_title: "Take over call?",
    call_take_over: "Take Over",
    call_mute: "Mute",
    call_unmute: "Unmute",
    call_camera_on: "Camera On",
    call_camera_off: "Camera Off",
    call_leave: "Leave",
    call_more_actions: "More actions",
    call_logs: "Logs",
    call_share_screen: "Share Screen",
    call_stop_sharing: "Stop Sharing",
    call_end_room: "End Room",
    call_close_logs: "Close Logs",
    call_controls: "Call controls",
    call_video_call: "Video call",
    call_video_feeds: "Video feeds",
    call_service_budget_grace_toast:
      "Service budget exhausted. Room will terminate in {minutes} minutes.",
    call_service_budget_grace_banner:
      "Service budget exhausted. Room will terminate in {minutes} minutes.",
    call_chat: "Chat",
    call_chat_title: "Chat",
    call_chat_empty: "No messages yet",
    call_chat_placeholder: "Type a message...",
    call_chat_send: "Send",
  },
  ru: {
    landing_secure_video_calls: "Безопасные видеозвонки",
    landing_enter_room: "Войти в комнату",
    landing_join_room_action: "Войти в комнату",
    landing_create_room_action: "Создать комнату",
    landing_enter_room_code: "Введите код комнаты",
    landing_try_again: "Попробовать снова",
    landing_room_code_helper: "Введите все 6 символов, чтобы продолжить.",
    landing_checking_room: "Проверка…",
    landing_checking_room_hint: "Проверяем, активна ли уже эта комната.",
    landing_room_found_hint: "Комната найдена. Можно войти.",
    landing_room_not_found_create_hint: "Комната не найдена. Вы можете создать её с этим кодом.",
    landing_token_required_hint: "Этот код комнаты ещё не используется.",
    landing_enter_token_prompt_action: "Введите жетон, чтобы создавать комнаты",
    landing_enter_token_hint: "Введите жетон, чтобы создавать новые комнаты",
    landing_recent: "Недавние",
    landing_edit_label: "Изменить название",
    landing_delete_room: "Удалить комнату",
    landing_save_label: "Сохранить название",
    landing_change_token: "Изменить жетон",
    landing_enter_new_token_placeholder: "Введите новый жетон",
    landing_cancel: "Отмена",
    landing_save: "Сохранить",
    landing_token_set: "Жетон задан",
    landing_host_admin_access_active: "Доступ host admin активен",
    landing_budget_admin_access_active: "Доступ budget admin активен",
    landing_change_token_action: "Изменить жетон",
    landing_clear_token: "Очистить жетон",
    landing_created_room: "Комната создана: {roomId}",
    landing_invalid_token: "Неверный жетон",
    landing_token_saved: "Жетон сохранён",
    call_room: "комната",
    call_copy_room_code: "Скопировать код комнаты",
    call_click_to_copy: "Нажмите, чтобы скопировать",
    call_room_code_copied: "Код комнаты скопирован",
    call_room_code_copy_failed: "Не удалось скопировать код комнаты",
    call_desktop_side_by_side: "Рядом",
    call_desktop_focus_remote: "Фокус на собеседнике",
    call_mobile_picture_in_picture: "Картинка в картинке",
    call_mobile_remote_only: "Только собеседник",
    call_you: "Вы",
    call_remote: "Собеседник",
    call_muted_badge: "Без звука",
    call_waiting_for_participant: "Ожидание участника...",
    call_participant_disconnected: "Участник отключился",
    call_participant_camera_off: "Камера участника выключена",
    call_mute: "Выключить звук",
    call_unmute: "Включить звук",
    call_camera_on: "Включить камеру",
    call_camera_off: "Выключить камеру",
    call_leave: "Выйти",
    call_more_actions: "Ещё",
    call_logs: "Логи",
    call_share_screen: "Поделиться экраном",
    call_stop_sharing: "Остановить показ",
    call_end_room: "Завершить комнату",
    call_close_logs: "Закрыть логи",
    call_controls: "Управление звонком",
    call_video_call: "Видеозвонок",
    call_video_feeds: "Видеопотоки",
  },
  zh: {
    landing_secure_video_calls: "安全视频通话",
    landing_enter_room: "输入房间",
    landing_join_room_action: "加入房间",
    landing_create_room_action: "创建房间",
    landing_enter_room_code: "输入房间代码",
    landing_try_again: "重试",
    landing_room_code_helper: "输入全部 6 个字符以继续。",
    landing_checking_room: "检查中…",
    landing_checking_room_hint: "正在检查此房间是否已处于活动状态。",
    landing_room_found_hint: "已找到房间。现在可以加入。",
    landing_room_not_found_create_hint: "未找到房间。你可以用此代码创建它。",
    landing_token_required_hint: "此房间代码尚未使用。",
    landing_enter_token_prompt_action: "输入令牌以创建房间",
    landing_enter_token_hint: "输入令牌以创建新房间",
    landing_recent: "最近",
    landing_edit_label: "编辑标签",
    landing_delete_room: "删除房间",
    landing_save_label: "保存标签",
    landing_change_token: "更改令牌",
    landing_enter_new_token_placeholder: "输入新令牌",
    landing_cancel: "取消",
    landing_save: "保存",
    landing_token_set: "令牌已设置",
    landing_host_admin_access_active: "主机管理员访问已启用",
    landing_budget_admin_access_active: "预算管理员访问已启用",
    landing_change_token_action: "更改令牌",
    landing_clear_token: "清除令牌",
    landing_created_room: "已创建房间：{roomId}",
    landing_invalid_token: "令牌无效",
    landing_token_saved: "令牌已保存",
    call_room: "房间",
    call_copy_room_code: "复制房间代码",
    call_click_to_copy: "点击复制",
    call_room_code_copied: "房间代码已复制",
    call_room_code_copy_failed: "无法复制房间代码",
    call_desktop_side_by_side: "并排",
    call_desktop_focus_remote: "聚焦对方",
    call_mobile_picture_in_picture: "画中画",
    call_mobile_remote_only: "仅远端",
    call_you: "你",
    call_remote: "对方",
    call_muted_badge: "静音",
    call_waiting_for_participant: "等待参与者...",
    call_participant_disconnected: "参与者已断开",
    call_participant_camera_off: "参与者摄像头已关闭",
    call_mute: "静音",
    call_unmute: "取消静音",
    call_camera_on: "打开摄像头",
    call_camera_off: "关闭摄像头",
    call_leave: "离开",
    call_more_actions: "更多操作",
    call_logs: "日志",
    call_share_screen: "共享屏幕",
    call_stop_sharing: "停止共享",
    call_end_room: "结束房间",
    call_close_logs: "关闭日志",
    call_controls: "通话控制",
    call_video_call: "视频通话",
    call_video_feeds: "视频画面",
  },
  hi: {
    landing_secure_video_calls: "सुरक्षित वीडियो कॉल",
    landing_enter_room: "कमरे में प्रवेश करें",
    landing_join_room_action: "कमरे में जुड़ें",
    landing_create_room_action: "कमरा बनाएं",
    landing_enter_room_code: "कमरे का कोड दर्ज करें",
    landing_try_again: "फिर से कोशिश करें",
    landing_room_code_helper: "जारी रखने के लिए सभी 6 अक्षर दर्ज करें।",
    landing_checking_room: "जांच हो रही है…",
    landing_checking_room_hint: "जांच रहे हैं कि क्या यह कमरा पहले से सक्रिय है।",
    landing_room_found_hint: "कमरा मिल गया। अब आप जुड़ सकते हैं।",
    landing_room_not_found_create_hint: "कमरा नहीं मिला। आप इसी कोड से इसे बना सकते हैं।",
    landing_token_required_hint: "यह रूम कोड अभी उपयोग में नहीं है।",
    landing_enter_token_prompt_action: "कमरे बनाने के लिए टोकन दर्ज करें",
    landing_enter_token_hint: "नए कमरे बनाने के लिए अपना टोकन दर्ज करें",
    landing_recent: "हाल के",
    landing_edit_label: "लेबल संपादित करें",
    landing_delete_room: "कमरा हटाएं",
    landing_save_label: "लेबल सहेजें",
    landing_change_token: "टोकन बदलें",
    landing_enter_new_token_placeholder: "नया टोकन दर्ज करें",
    landing_cancel: "रद्द करें",
    landing_save: "सहेजें",
    landing_token_set: "टोकन सेट है",
    landing_host_admin_access_active: "host admin पहुँच सक्रिय है",
    landing_budget_admin_access_active: "budget admin पहुँच सक्रिय है",
    landing_change_token_action: "टोकन बदलें",
    landing_clear_token: "टोकन साफ़ करें",
    landing_created_room: "कमरा बनाया गया: {roomId}",
    landing_invalid_token: "अमान्य टोकन",
    landing_token_saved: "टोकन सहेजा गया",
    call_room: "कमरा",
    call_copy_room_code: "कमरे का कोड कॉपी करें",
    call_click_to_copy: "कॉपी करने के लिए क्लिक करें",
    call_room_code_copied: "कमरे का कोड कॉपी हो गया",
    call_room_code_copy_failed: "कमरे का कोड कॉपी नहीं हो सका",
    call_desktop_side_by_side: "साथ-साथ",
    call_desktop_focus_remote: "दूसरे पर फ़ोकस",
    call_mobile_picture_in_picture: "पिक्चर-इन-पिक्चर",
    call_mobile_remote_only: "केवल सामने वाला",
    call_you: "आप",
    call_remote: "सामने वाला",
    call_muted_badge: "म्यूट",
    call_waiting_for_participant: "प्रतिभागी की प्रतीक्षा हो रही है...",
    call_participant_disconnected: "प्रतिभागी डिस्कनेक्ट हो गया",
    call_participant_camera_off: "प्रतिभागी का कैमरा बंद है",
    call_mute: "म्यूट",
    call_unmute: "अनम्यूट",
    call_camera_on: "कैमरा चालू",
    call_camera_off: "कैमरा बंद",
    call_leave: "छोड़ें",
    call_more_actions: "और",
    call_logs: "लॉग",
    call_share_screen: "स्क्रीन साझा करें",
    call_stop_sharing: "साझा करना रोकें",
    call_end_room: "कमरा समाप्त करें",
    call_close_logs: "लॉग बंद करें",
    call_controls: "कॉल नियंत्रण",
    call_video_call: "वीडियो कॉल",
    call_video_feeds: "वीडियो फ़ीड",
  },
  ko: {
    landing_secure_video_calls: "안전한 화상 통화",
    landing_enter_room: "방 입장",
    landing_join_room_action: "방 참가",
    landing_create_room_action: "방 만들기",
    landing_enter_room_code: "방 코드 입력",
    landing_try_again: "다시 시도",
    landing_room_code_helper: "계속하려면 6자를 모두 입력하세요.",
    landing_checking_room: "확인 중…",
    landing_checking_room_hint: "이 방이 이미 활성 상태인지 확인하는 중입니다.",
    landing_room_found_hint: "방을 찾았습니다. 지금 참가할 수 있습니다.",
    landing_room_not_found_create_hint: "방을 찾지 못했습니다. 이 코드로 새로 만들 수 있습니다.",
    landing_token_required_hint: "이 방 코드는 아직 사용되지 않았습니다.",
    landing_enter_token_prompt_action: "방을 만들려면 토큰을 입력하세요",
    landing_enter_token_hint: "새 방을 만들려면 토큰을 입력하세요",
    landing_recent: "최근",
    landing_edit_label: "라벨 수정",
    landing_delete_room: "방 삭제",
    landing_save_label: "라벨 저장",
    landing_change_token: "토큰 변경",
    landing_enter_new_token_placeholder: "새 토큰 입력",
    landing_cancel: "취소",
    landing_save: "저장",
    landing_token_set: "토큰 설정됨",
    landing_host_admin_access_active: "host admin 액세스 활성",
    landing_budget_admin_access_active: "budget admin 액세스 활성",
    landing_change_token_action: "토큰 변경",
    landing_clear_token: "토큰 지우기",
    landing_created_room: "방 생성됨: {roomId}",
    landing_invalid_token: "잘못된 토큰",
    landing_token_saved: "토큰이 저장되었습니다",
    call_room: "방",
    call_copy_room_code: "방 코드 복사",
    call_click_to_copy: "클릭하여 복사",
    call_room_code_copied: "방 코드가 복사되었습니다",
    call_room_code_copy_failed: "방 코드를 복사할 수 없습니다",
    call_desktop_side_by_side: "나란히",
    call_desktop_focus_remote: "상대 화면 집중",
    call_mobile_picture_in_picture: "화면 속 화면",
    call_mobile_remote_only: "상대만",
    call_you: "나",
    call_remote: "상대",
    call_muted_badge: "음소거",
    call_waiting_for_participant: "참가자를 기다리는 중...",
    call_participant_disconnected: "참가자가 연결을 끊었습니다",
    call_participant_camera_off: "참가자의 카메라가 꺼져 있습니다",
    call_mute: "음소거",
    call_unmute: "음소거 해제",
    call_camera_on: "카메라 켜기",
    call_camera_off: "카메라 끄기",
    call_leave: "나가기",
    call_more_actions: "더보기",
    call_logs: "로그",
    call_share_screen: "화면 공유",
    call_stop_sharing: "공유 중지",
    call_end_room: "방 종료",
    call_close_logs: "로그 닫기",
    call_controls: "통화 제어",
    call_video_call: "화상 통화",
    call_video_feeds: "비디오 피드",
  },
  ja: {
    landing_secure_video_calls: "安全なビデオ通話",
    landing_enter_room: "ルームに入る",
    landing_join_room_action: "ルームに参加",
    landing_create_room_action: "ルームを作成",
    landing_enter_room_code: "ルームコードを入力",
    landing_try_again: "もう一度試す",
    landing_room_code_helper: "続行するには6文字すべてを入力してください。",
    landing_checking_room: "確認中…",
    landing_checking_room_hint: "このルームがすでにアクティブか確認しています。",
    landing_room_found_hint: "ルームが見つかりました。今すぐ参加できます。",
    landing_room_not_found_create_hint: "ルームが見つかりません。このコードで作成できます。",
    landing_token_required_hint: "このルームコードはまだ使われていません。",
    landing_enter_token_prompt_action: "ルームを作成するにはトークンを入力",
    landing_enter_token_hint: "新しいルームを作成するにはトークンを入力してください",
    landing_recent: "最近",
    landing_edit_label: "ラベルを編集",
    landing_delete_room: "ルームを削除",
    landing_save_label: "ラベルを保存",
    landing_change_token: "トークンを変更",
    landing_enter_new_token_placeholder: "新しいトークンを入力",
    landing_cancel: "キャンセル",
    landing_save: "保存",
    landing_token_set: "トークン設定済み",
    landing_host_admin_access_active: "host admin アクセス有効",
    landing_budget_admin_access_active: "budget admin アクセス有効",
    landing_change_token_action: "トークンを変更",
    landing_clear_token: "トークンを消去",
    landing_created_room: "ルームを作成しました: {roomId}",
    landing_invalid_token: "無効なトークンです",
    landing_token_saved: "トークンを保存しました",
    call_room: "ルーム",
    call_copy_room_code: "ルームコードをコピー",
    call_click_to_copy: "クリックしてコピー",
    call_room_code_copied: "ルームコードをコピーしました",
    call_room_code_copy_failed: "ルームコードをコピーできませんでした",
    call_desktop_side_by_side: "左右表示",
    call_desktop_focus_remote: "相手を大きく表示",
    call_mobile_picture_in_picture: "ピクチャーインピクチャー",
    call_mobile_remote_only: "相手のみ",
    call_you: "あなた",
    call_remote: "相手",
    call_muted_badge: "ミュート",
    call_waiting_for_participant: "参加者を待っています...",
    call_participant_disconnected: "参加者が切断されました",
    call_participant_camera_off: "参加者のカメラはオフです",
    call_mute: "ミュート",
    call_unmute: "ミュート解除",
    call_camera_on: "カメラオン",
    call_camera_off: "カメラオフ",
    call_leave: "退出",
    call_more_actions: "その他",
    call_logs: "ログ",
    call_share_screen: "画面共有",
    call_stop_sharing: "共有を停止",
    call_end_room: "ルームを終了",
    call_close_logs: "ログを閉じる",
    call_controls: "通話コントロール",
    call_video_call: "ビデオ通話",
    call_video_feeds: "ビデオフィード",
  },
  es: {
    landing_secure_video_calls: "Videollamadas seguras",
    landing_enter_room: "Entrar a una sala",
    landing_join_room_action: "Unirse a la sala",
    landing_create_room_action: "Crear sala",
    landing_enter_room_code: "Ingresa el código de la sala",
    landing_try_again: "Intentar de nuevo",
    landing_room_code_helper: "Ingresa las 6 letras para continuar.",
    landing_checking_room: "Comprobando…",
    landing_checking_room_hint: "Comprobando si esta sala ya está activa.",
    landing_room_found_hint: "Sala encontrada. Puedes unirte ahora.",
    landing_room_not_found_create_hint: "No se encontró la sala. Puedes crearla con este código.",
    landing_token_required_hint: "Este código de sala aún no se usa.",
    landing_enter_token_prompt_action: "Ingresa un token para crear salas",
    landing_enter_token_hint: "Ingresa tu token para crear salas nuevas",
    landing_recent: "Recientes",
    landing_edit_label: "Editar etiqueta",
    landing_delete_room: "Eliminar sala",
    landing_save_label: "Guardar etiqueta",
    landing_change_token: "Cambiar token",
    landing_enter_new_token_placeholder: "Ingresa un token nuevo",
    landing_cancel: "Cancelar",
    landing_save: "Guardar",
    landing_token_set: "Token configurado",
    landing_host_admin_access_active: "acceso de host admin activo",
    landing_budget_admin_access_active: "acceso de budget admin activo",
    landing_change_token_action: "Cambiar token",
    landing_clear_token: "Borrar token",
    landing_created_room: "Sala creada: {roomId}",
    landing_invalid_token: "Token inválido",
    landing_token_saved: "Token guardado",
    call_room: "sala",
    call_copy_room_code: "Copiar código de sala",
    call_click_to_copy: "Haz clic para copiar",
    call_room_code_copied: "Código de sala copiado",
    call_room_code_copy_failed: "No se pudo copiar el código de sala",
    call_desktop_side_by_side: "Lado a lado",
    call_desktop_focus_remote: "Enfocar remoto",
    call_mobile_picture_in_picture: "Imagen en imagen",
    call_mobile_remote_only: "Solo remoto",
    call_you: "Tú",
    call_remote: "Remoto",
    call_muted_badge: "Silenciado",
    call_waiting_for_participant: "Esperando al participante...",
    call_participant_disconnected: "El participante se desconectó",
    call_participant_camera_off: "La cámara del participante está apagada",
    call_mute: "Silenciar",
    call_unmute: "Activar audio",
    call_camera_on: "Encender cámara",
    call_camera_off: "Apagar cámara",
    call_leave: "Salir",
    call_more_actions: "Más acciones",
    call_logs: "Registros",
    call_share_screen: "Compartir pantalla",
    call_stop_sharing: "Detener uso compartido",
    call_end_room: "Finalizar sala",
    call_close_logs: "Cerrar registros",
    call_controls: "Controles de llamada",
    call_video_call: "Videollamada",
    call_video_feeds: "Videos",
  },
  pt: {
    landing_secure_video_calls: "Chamadas de vídeo seguras",
    landing_enter_room: "Entrar em uma sala",
    landing_join_room_action: "Entrar na sala",
    landing_create_room_action: "Criar sala",
    landing_enter_room_code: "Digite o código da sala",
    landing_try_again: "Tentar novamente",
    landing_room_code_helper: "Digite as 6 letras para continuar.",
    landing_checking_room: "Verificando…",
    landing_checking_room_hint: "Verificando se esta sala já está ativa.",
    landing_room_found_hint: "Sala encontrada. Você pode entrar agora.",
    landing_room_not_found_create_hint: "Sala não encontrada. Você pode criá-la com este código.",
    landing_token_required_hint: "Este código de sala ainda não está em uso.",
    landing_enter_token_prompt_action: "Digite um token para criar salas",
    landing_enter_token_hint: "Digite seu token para criar novas salas",
    landing_recent: "Recentes",
    landing_edit_label: "Editar rótulo",
    landing_delete_room: "Excluir sala",
    landing_save_label: "Salvar rótulo",
    landing_change_token: "Alterar token",
    landing_enter_new_token_placeholder: "Digite um novo token",
    landing_cancel: "Cancelar",
    landing_save: "Salvar",
    landing_token_set: "Token definido",
    landing_host_admin_access_active: "acesso de host admin ativo",
    landing_budget_admin_access_active: "acesso de budget admin ativo",
    landing_change_token_action: "Alterar token",
    landing_clear_token: "Limpar token",
    landing_created_room: "Sala criada: {roomId}",
    landing_invalid_token: "Token inválido",
    landing_token_saved: "Token salvo",
    call_room: "sala",
    call_copy_room_code: "Copiar código da sala",
    call_click_to_copy: "Clique para copiar",
    call_room_code_copied: "Código da sala copiado",
    call_room_code_copy_failed: "Não foi possível copiar o código da sala",
    call_desktop_side_by_side: "Lado a lado",
    call_desktop_focus_remote: "Focar remoto",
    call_mobile_picture_in_picture: "Imagem em imagem",
    call_mobile_remote_only: "Somente remoto",
    call_you: "Você",
    call_remote: "Remoto",
    call_muted_badge: "Mudo",
    call_waiting_for_participant: "Aguardando participante...",
    call_participant_disconnected: "O participante desconectou",
    call_participant_camera_off: "A câmera do participante está desligada",
    call_mute: "Silenciar",
    call_unmute: "Ativar áudio",
    call_camera_on: "Ligar câmera",
    call_camera_off: "Desligar câmera",
    call_leave: "Sair",
    call_more_actions: "Mais ações",
    call_logs: "Logs",
    call_share_screen: "Compartilhar tela",
    call_stop_sharing: "Parar compartilhamento",
    call_end_room: "Encerrar sala",
    call_close_logs: "Fechar logs",
    call_controls: "Controles da chamada",
    call_video_call: "Chamada de vídeo",
    call_video_feeds: "Vídeos",
  },
  ar: {
    landing_secure_video_calls: "مكالمات فيديو آمنة",
    landing_enter_room: "دخول غرفة",
    landing_join_room_action: "الانضمام إلى الغرفة",
    landing_create_room_action: "إنشاء غرفة",
    landing_enter_room_code: "أدخل رمز الغرفة",
    landing_try_again: "حاول مرة أخرى",
    landing_room_code_helper: "أدخل الأحرف الستة كلها للمتابعة.",
    landing_checking_room: "جارٍ التحقق…",
    landing_checking_room_hint: "يجري التحقق مما إذا كانت هذه الغرفة نشطة بالفعل.",
    landing_room_found_hint: "تم العثور على الغرفة. يمكنك الانضمام الآن.",
    landing_room_not_found_create_hint: "لم يتم العثور على الغرفة. يمكنك إنشاؤها بهذا الرمز.",
    landing_token_required_hint: "رمز الغرفة هذا غير مستخدم بعد.",
    landing_enter_token_prompt_action: "أدخل رمزًا لإنشاء الغرف",
    landing_enter_token_hint: "أدخل الرمز لإنشاء غرف جديدة",
    landing_recent: "الأخيرة",
    landing_edit_label: "تعديل التسمية",
    landing_delete_room: "حذف الغرفة",
    landing_save_label: "حفظ التسمية",
    landing_change_token: "تغيير الرمز",
    landing_enter_new_token_placeholder: "أدخل رمزًا جديدًا",
    landing_cancel: "إلغاء",
    landing_save: "حفظ",
    landing_token_set: "تم تعيين الرمز",
    landing_host_admin_access_active: "وصول host admin نشط",
    landing_budget_admin_access_active: "وصول budget admin نشط",
    landing_change_token_action: "تغيير الرمز",
    landing_clear_token: "مسح الرمز",
    landing_created_room: "تم إنشاء الغرفة: {roomId}",
    landing_invalid_token: "رمز غير صالح",
    landing_token_saved: "تم حفظ الرمز",
    call_room: "غرفة",
    call_copy_room_code: "نسخ رمز الغرفة",
    call_click_to_copy: "انقر للنسخ",
    call_room_code_copied: "تم نسخ رمز الغرفة",
    call_room_code_copy_failed: "تعذر نسخ رمز الغرفة",
    call_desktop_side_by_side: "جنبًا إلى جنب",
    call_desktop_focus_remote: "التركيز على الطرف الآخر",
    call_mobile_picture_in_picture: "صورة داخل صورة",
    call_mobile_remote_only: "الطرف الآخر فقط",
    call_you: "أنت",
    call_remote: "الطرف الآخر",
    call_muted_badge: "مكتوم",
    call_waiting_for_participant: "في انتظار المشارك...",
    call_participant_disconnected: "تم قطع اتصال المشارك",
    call_participant_camera_off: "كاميرا المشارك متوقفة",
    call_mute: "كتم",
    call_unmute: "إلغاء الكتم",
    call_camera_on: "تشغيل الكاميرا",
    call_camera_off: "إيقاف الكاميرا",
    call_leave: "مغادرة",
    call_more_actions: "المزيد",
    call_logs: "السجلات",
    call_share_screen: "مشاركة الشاشة",
    call_stop_sharing: "إيقاف المشاركة",
    call_end_room: "إنهاء الغرفة",
    call_close_logs: "إغلاق السجلات",
    call_controls: "عناصر التحكم بالمكالمة",
    call_video_call: "مكالمة فيديو",
    call_video_feeds: "مقاطع الفيديو",
  },
  id: {
    landing_secure_video_calls: "Panggilan video aman",
    landing_enter_room: "Masuk ke ruang",
    landing_join_room_action: "Gabung ke ruang",
    landing_create_room_action: "Buat ruang",
    landing_enter_room_code: "Masukkan kode ruang",
    landing_try_again: "Coba lagi",
    landing_room_code_helper: "Masukkan semua 6 huruf untuk melanjutkan.",
    landing_checking_room: "Memeriksa…",
    landing_checking_room_hint: "Memeriksa apakah ruang ini sudah aktif.",
    landing_room_found_hint: "Ruang ditemukan. Anda bisa bergabung sekarang.",
    landing_room_not_found_create_hint:
      "Ruang tidak ditemukan. Anda dapat membuatnya dengan kode ini.",
    landing_token_required_hint: "Kode ruang ini belum digunakan.",
    landing_enter_token_prompt_action: "Masukkan token untuk membuat ruang",
    landing_enter_token_hint: "Masukkan token untuk membuat ruang baru",
    landing_recent: "Terbaru",
    landing_edit_label: "Ubah label",
    landing_delete_room: "Hapus ruang",
    landing_save_label: "Simpan label",
    landing_change_token: "Ubah token",
    landing_enter_new_token_placeholder: "Masukkan token baru",
    landing_cancel: "Batal",
    landing_save: "Simpan",
    landing_token_set: "Token tersimpan",
    landing_host_admin_access_active: "akses host admin aktif",
    landing_budget_admin_access_active: "akses budget admin aktif",
    landing_change_token_action: "Ubah token",
    landing_clear_token: "Hapus token",
    landing_created_room: "Ruang dibuat: {roomId}",
    landing_invalid_token: "Token tidak valid",
    landing_token_saved: "Token disimpan",
    call_room: "ruang",
    call_copy_room_code: "Salin kode ruang",
    call_click_to_copy: "Klik untuk menyalin",
    call_room_code_copied: "Kode ruang disalin",
    call_room_code_copy_failed: "Tidak dapat menyalin kode ruang",
    call_desktop_side_by_side: "Berdampingan",
    call_desktop_focus_remote: "Fokus ke lawan bicara",
    call_mobile_picture_in_picture: "Gambar dalam gambar",
    call_mobile_remote_only: "Hanya lawan bicara",
    call_you: "Anda",
    call_remote: "Lawan bicara",
    call_muted_badge: "Senyap",
    call_waiting_for_participant: "Menunggu peserta...",
    call_participant_disconnected: "Peserta terputus",
    call_participant_camera_off: "Kamera peserta mati",
    call_mute: "Senyapkan",
    call_unmute: "Bunyikan",
    call_camera_on: "Nyalakan kamera",
    call_camera_off: "Matikan kamera",
    call_leave: "Keluar",
    call_more_actions: "Lainnya",
    call_logs: "Log",
    call_share_screen: "Bagikan layar",
    call_stop_sharing: "Hentikan berbagi",
    call_end_room: "Akhiri ruang",
    call_close_logs: "Tutup log",
    call_controls: "Kontrol panggilan",
    call_video_call: "Panggilan video",
    call_video_feeds: "Umpan video",
  },
  fr: {
    landing_secure_video_calls: "Appels vidéo sécurisés",
    landing_enter_room: "Entrer dans une salle",
    landing_join_room_action: "Rejoindre la salle",
    landing_create_room_action: "Créer une salle",
    landing_enter_room_code: "Entrez le code de la salle",
    landing_try_again: "Réessayer",
    landing_room_code_helper: "Entrez les 6 caractères pour continuer.",
    landing_checking_room: "Vérification…",
    landing_checking_room_hint: "Vérification si cette salle est déjà active.",
    landing_room_found_hint: "Salle trouvée. Vous pouvez la rejoindre maintenant.",
    landing_room_not_found_create_hint: "Salle introuvable. Vous pouvez la créer avec ce code.",
    landing_token_required_hint: "Ce code de salle n'est pas encore utilisé.",
    landing_enter_token_prompt_action: "Entrez un jeton pour créer des salles",
    landing_enter_token_hint: "Entrez votre jeton pour créer de nouvelles salles",
    landing_recent: "Récentes",
    landing_edit_label: "Modifier l’étiquette",
    landing_delete_room: "Supprimer la salle",
    landing_save_label: "Enregistrer l’étiquette",
    landing_change_token: "Modifier le jeton",
    landing_enter_new_token_placeholder: "Entrez un nouveau jeton",
    landing_cancel: "Annuler",
    landing_save: "Enregistrer",
    landing_token_set: "Jeton défini",
    landing_host_admin_access_active: "accès host admin actif",
    landing_budget_admin_access_active: "accès budget admin actif",
    landing_change_token_action: "Modifier le jeton",
    landing_clear_token: "Effacer le jeton",
    landing_created_room: "Salle créée : {roomId}",
    landing_invalid_token: "Jeton invalide",
    landing_token_saved: "Jeton enregistré",
    call_room: "salle",
    call_copy_room_code: "Copier le code de la salle",
    call_click_to_copy: "Cliquer pour copier",
    call_room_code_copied: "Code de la salle copié",
    call_room_code_copy_failed: "Impossible de copier le code de la salle",
    call_desktop_side_by_side: "Côte à côte",
    call_desktop_focus_remote: "Mettre l’autre en avant",
    call_mobile_picture_in_picture: "Image dans l’image",
    call_mobile_remote_only: "Distant uniquement",
    call_you: "Vous",
    call_remote: "Distant",
    call_muted_badge: "Muet",
    call_waiting_for_participant: "En attente du participant...",
    call_participant_disconnected: "Le participant s’est déconnecté",
    call_participant_camera_off: "La caméra du participant est désactivée",
    call_mute: "Couper le micro",
    call_unmute: "Réactiver le micro",
    call_camera_on: "Activer la caméra",
    call_camera_off: "Désactiver la caméra",
    call_leave: "Quitter",
    call_more_actions: "Plus d’actions",
    call_logs: "Journaux",
    call_share_screen: "Partager l’écran",
    call_stop_sharing: "Arrêter le partage",
    call_end_room: "Terminer la salle",
    call_close_logs: "Fermer les journaux",
    call_controls: "Contrôles d’appel",
    call_video_call: "Appel vidéo",
    call_video_feeds: "Flux vidéo",
  },
  bn: {
    landing_secure_video_calls: "নিরাপদ ভিডিও কল",
    landing_enter_room: "রুমে প্রবেশ করুন",
    landing_join_room_action: "রুমে যোগ দিন",
    landing_create_room_action: "রুম তৈরি করুন",
    landing_enter_room_code: "রুম কোড লিখুন",
    landing_try_again: "আবার চেষ্টা করুন",
    landing_room_code_helper: "চালিয়ে যেতে সব ৬টি অক্ষর লিখুন।",
    landing_checking_room: "পরীক্ষা করা হচ্ছে…",
    landing_checking_room_hint: "এই রুমটি আগে থেকেই সক্রিয় কি না দেখা হচ্ছে।",
    landing_room_found_hint: "রুম পাওয়া গেছে। এখন যোগ দিতে পারেন।",
    landing_room_not_found_create_hint: "রুম পাওয়া যায়নি। এই কোড দিয়ে আপনি এটি তৈরি করতে পারেন।",
    landing_token_required_hint: "এই রুম কোডটি এখনও ব্যবহার হয়নি।",
    landing_enter_token_prompt_action: "রুম তৈরি করতে টোকেন দিন",
    landing_enter_token_hint: "নতুন রুম তৈরি করতে আপনার টোকেন দিন",
    landing_recent: "সাম্প্রতিক",
    landing_edit_label: "লেবেল সম্পাদনা করুন",
    landing_delete_room: "রুম মুছুন",
    landing_save_label: "লেবেল সংরক্ষণ করুন",
    landing_change_token: "টোকেন পরিবর্তন করুন",
    landing_enter_new_token_placeholder: "নতুন টোকেন দিন",
    landing_cancel: "বাতিল",
    landing_save: "সংরক্ষণ করুন",
    landing_token_set: "টোকেন সেট আছে",
    landing_host_admin_access_active: "host admin প্রবেশাধিকার সক্রিয়",
    landing_budget_admin_access_active: "budget admin প্রবেশাধিকার সক্রিয়",
    landing_change_token_action: "টোকেন পরিবর্তন করুন",
    landing_clear_token: "টোকেন মুছুন",
    landing_created_room: "রুম তৈরি হয়েছে: {roomId}",
    landing_invalid_token: "অবৈধ টোকেন",
    landing_token_saved: "টোকেন সংরক্ষিত হয়েছে",
    call_room: "রুম",
    call_copy_room_code: "রুম কোড কপি করুন",
    call_click_to_copy: "কপি করতে ক্লিক করুন",
    call_room_code_copied: "রুম কোড কপি হয়েছে",
    call_room_code_copy_failed: "রুম কোড কপি করা যায়নি",
    call_desktop_side_by_side: "পাশাপাশি",
    call_desktop_focus_remote: "অন্য পক্ষকে বড় করে দেখান",
    call_mobile_picture_in_picture: "পিকচার-ইন-পিকচার",
    call_mobile_remote_only: "শুধু অন্য পক্ষ",
    call_you: "আপনি",
    call_remote: "অন্য পক্ষ",
    call_muted_badge: "নিঃশব্দ",
    call_waiting_for_participant: "অংশগ্রহণকারীর জন্য অপেক্ষা করা হচ্ছে...",
    call_participant_disconnected: "অংশগ্রহণকারী সংযোগ বিচ্ছিন্ন হয়েছে",
    call_participant_camera_off: "অংশগ্রহণকারীর ক্যামেরা বন্ধ",
    call_mute: "মিউট",
    call_unmute: "আনমিউট",
    call_camera_on: "ক্যামেরা চালু",
    call_camera_off: "ক্যামেরা বন্ধ",
    call_leave: "ছেড়ে দিন",
    call_more_actions: "আরও",
    call_logs: "লগ",
    call_share_screen: "স্ক্রিন শেয়ার করুন",
    call_stop_sharing: "শেয়ার বন্ধ করুন",
    call_end_room: "রুম শেষ করুন",
    call_close_logs: "লগ বন্ধ করুন",
    call_controls: "কল নিয়ন্ত্রণ",
    call_video_call: "ভিডিও কল",
    call_video_feeds: "ভিডিও ফিড",
  },
  tr: {
    landing_secure_video_calls: "Güvenli video görüşmeleri",
    landing_enter_room: "Odaya gir",
    landing_join_room_action: "Odaya katıl",
    landing_create_room_action: "Oda oluştur",
    landing_enter_room_code: "Oda kodunu gir",
    landing_try_again: "Tekrar dene",
    landing_room_code_helper: "Devam etmek için 6 karakterin tamamını girin.",
    landing_checking_room: "Kontrol ediliyor…",
    landing_checking_room_hint: "Bu odanın zaten aktif olup olmadığı kontrol ediliyor.",
    landing_room_found_hint: "Oda bulundu. Şimdi katılabilirsiniz.",
    landing_room_not_found_create_hint: "Oda bulunamadı. Bu kodla oluşturabilirsiniz.",
    landing_token_required_hint: "Bu oda kodu henüz kullanılmıyor.",
    landing_enter_token_prompt_action: "Oda oluşturmak için jeton girin",
    landing_enter_token_hint: "Yeni odalar oluşturmak için jetonunuzu girin",
    landing_recent: "Son",
    landing_edit_label: "Etiketi düzenle",
    landing_delete_room: "Odayı sil",
    landing_save_label: "Etiketi kaydet",
    landing_change_token: "Jetonu değiştir",
    landing_enter_new_token_placeholder: "Yeni jetonu girin",
    landing_cancel: "İptal",
    landing_save: "Kaydet",
    landing_token_set: "Jeton ayarlı",
    landing_host_admin_access_active: "host admin erişimi etkin",
    landing_budget_admin_access_active: "budget admin erişimi etkin",
    landing_change_token_action: "Jetonu değiştir",
    landing_clear_token: "Jetonu temizle",
    landing_created_room: "Oda oluşturuldu: {roomId}",
    landing_invalid_token: "Geçersiz jeton",
    landing_token_saved: "Jeton kaydedildi",
    call_room: "oda",
    call_copy_room_code: "Oda kodunu kopyala",
    call_click_to_copy: "Kopyalamak için tıkla",
    call_room_code_copied: "Oda kodu kopyalandı",
    call_room_code_copy_failed: "Oda kodu kopyalanamadı",
    call_desktop_side_by_side: "Yan yana",
    call_desktop_focus_remote: "Uzağı öne çıkar",
    call_mobile_picture_in_picture: "Resim içinde resim",
    call_mobile_remote_only: "Yalnızca karşı taraf",
    call_you: "Sen",
    call_remote: "Karşı taraf",
    call_muted_badge: "Sessiz",
    call_waiting_for_participant: "Katılımcı bekleniyor...",
    call_participant_disconnected: "Katılımcının bağlantısı kesildi",
    call_participant_camera_off: "Katılımcının kamerası kapalı",
    call_mute: "Sustur",
    call_unmute: "Sesi aç",
    call_camera_on: "Kamerayı Aç",
    call_camera_off: "Kamerayı Kapat",
    call_leave: "Ayrıl",
    call_more_actions: "Daha fazla",
    call_logs: "Kayıtlar",
    call_share_screen: "Ekranı Paylaş",
    call_stop_sharing: "Paylaşımı Durdur",
    call_end_room: "Odayı Bitir",
    call_close_logs: "Kayıtları Kapat",
    call_controls: "Çağrı kontrolleri",
    call_video_call: "Video görüşmesi",
    call_video_feeds: "Video akışları",
  },
  vi: {
    landing_secure_video_calls: "Cuộc gọi video an toàn",
    landing_enter_room: "Vào phòng",
    landing_join_room_action: "Tham gia phòng",
    landing_create_room_action: "Tạo phòng",
    landing_enter_room_code: "Nhập mã phòng",
    landing_try_again: "Thử lại",
    landing_room_code_helper: "Nhập đủ 6 ký tự để tiếp tục.",
    landing_checking_room: "Đang kiểm tra…",
    landing_checking_room_hint: "Đang kiểm tra xem phòng này đã hoạt động chưa.",
    landing_room_found_hint: "Đã tìm thấy phòng. Bạn có thể tham gia ngay.",
    landing_room_not_found_create_hint: "Không tìm thấy phòng. Bạn có thể tạo phòng với mã này.",
    landing_token_required_hint: "Mã phòng này chưa được dùng.",
    landing_enter_token_prompt_action: "Nhập token để tạo phòng",
    landing_enter_token_hint: "Nhập mã token để tạo phòng mới",
    landing_recent: "Gần đây",
    landing_edit_label: "Sửa nhãn",
    landing_delete_room: "Xóa phòng",
    landing_save_label: "Lưu nhãn",
    landing_change_token: "Đổi token",
    landing_enter_new_token_placeholder: "Nhập token mới",
    landing_cancel: "Hủy",
    landing_save: "Lưu",
    landing_token_set: "Đã đặt token",
    landing_host_admin_access_active: "quyền truy cập host admin đang hoạt động",
    landing_budget_admin_access_active: "quyền truy cập budget admin đang hoạt động",
    landing_change_token_action: "Đổi token",
    landing_clear_token: "Xóa token",
    landing_created_room: "Đã tạo phòng: {roomId}",
    landing_invalid_token: "Token không hợp lệ",
    landing_token_saved: "Đã lưu token",
    call_room: "phòng",
    call_copy_room_code: "Sao chép mã phòng",
    call_click_to_copy: "Nhấp để sao chép",
    call_room_code_copied: "Đã sao chép mã phòng",
    call_room_code_copy_failed: "Không thể sao chép mã phòng",
    call_desktop_side_by_side: "Cạnh nhau",
    call_desktop_focus_remote: "Tập trung người bên kia",
    call_mobile_picture_in_picture: "Hình trong hình",
    call_mobile_remote_only: "Chỉ người bên kia",
    call_you: "Bạn",
    call_remote: "Người bên kia",
    call_muted_badge: "Tắt tiếng",
    call_waiting_for_participant: "Đang chờ người tham gia...",
    call_participant_disconnected: "Người tham gia đã ngắt kết nối",
    call_participant_camera_off: "Camera của người tham gia đã tắt",
    call_mute: "Tắt tiếng",
    call_unmute: "Bật tiếng",
    call_camera_on: "Bật camera",
    call_camera_off: "Tắt camera",
    call_leave: "Rời đi",
    call_more_actions: "Thêm",
    call_logs: "Nhật ký",
    call_share_screen: "Chia sẻ màn hình",
    call_stop_sharing: "Dừng chia sẻ",
    call_end_room: "Kết thúc phòng",
    call_close_logs: "Đóng nhật ký",
    call_controls: "Điều khiển cuộc gọi",
    call_video_call: "Cuộc gọi video",
    call_video_feeds: "Luồng video",
  },
  th: {
    landing_secure_video_calls: "วิดีโอคอลที่ปลอดภัย",
    landing_enter_room: "เข้าห้อง",
    landing_join_room_action: "เข้าร่วมห้อง",
    landing_create_room_action: "สร้างห้อง",
    landing_enter_room_code: "กรอกรหัสห้อง",
    landing_try_again: "ลองอีกครั้ง",
    landing_room_code_helper: "กรอกให้ครบทั้ง 6 ตัวอักษรเพื่อดำเนินการต่อ",
    landing_checking_room: "กำลังตรวจสอบ…",
    landing_checking_room_hint: "กำลังตรวจสอบว่าห้องนี้เปิดใช้งานอยู่แล้วหรือไม่",
    landing_room_found_hint: "พบห้องแล้ว คุณสามารถเข้าร่วมได้ทันที",
    landing_room_not_found_create_hint: "ไม่พบห้อง คุณสามารถสร้างห้องด้วยรหัสนี้ได้",
    landing_token_required_hint: "รหัสห้องนี้ยังไม่ถูกใช้",
    landing_enter_token_prompt_action: "กรอกโทเคนเพื่อสร้างห้อง",
    landing_enter_token_hint: "กรอกโทเคนเพื่อสร้างห้องใหม่",
    landing_recent: "ล่าสุด",
    landing_edit_label: "แก้ไขป้ายกำกับ",
    landing_delete_room: "ลบห้อง",
    landing_save_label: "บันทึกป้ายกำกับ",
    landing_change_token: "เปลี่ยนโทเคน",
    landing_enter_new_token_placeholder: "กรอกโทเคนใหม่",
    landing_cancel: "ยกเลิก",
    landing_save: "บันทึก",
    landing_token_set: "ตั้งค่าโทเคนแล้ว",
    landing_host_admin_access_active: "สิทธิ์ host admin ใช้งานอยู่",
    landing_budget_admin_access_active: "สิทธิ์ budget admin ใช้งานอยู่",
    landing_change_token_action: "เปลี่ยนโทเคน",
    landing_clear_token: "ล้างโทเคน",
    landing_created_room: "สร้างห้องแล้ว: {roomId}",
    landing_invalid_token: "โทเคนไม่ถูกต้อง",
    landing_token_saved: "บันทึกโทเคนแล้ว",
    call_room: "ห้อง",
    call_copy_room_code: "คัดลอกรหัสห้อง",
    call_click_to_copy: "คลิกเพื่อคัดลอก",
    call_room_code_copied: "คัดลอกรหัสห้องแล้ว",
    call_room_code_copy_failed: "ไม่สามารถคัดลอกรหัสห้องได้",
    call_desktop_side_by_side: "วางข้างกัน",
    call_desktop_focus_remote: "โฟกัสอีกฝั่ง",
    call_mobile_picture_in_picture: "ภาพซ้อนภาพ",
    call_mobile_remote_only: "แสดงอีกฝั่งเท่านั้น",
    call_you: "คุณ",
    call_remote: "อีกฝั่ง",
    call_muted_badge: "ปิดเสียง",
    call_waiting_for_participant: "กำลังรอผู้เข้าร่วม...",
    call_participant_disconnected: "ผู้เข้าร่วมตัดการเชื่อมต่อแล้ว",
    call_participant_camera_off: "กล้องของผู้เข้าร่วมปิดอยู่",
    call_mute: "ปิดเสียง",
    call_unmute: "เปิดเสียง",
    call_camera_on: "เปิดกล้อง",
    call_camera_off: "ปิดกล้อง",
    call_leave: "ออก",
    call_more_actions: "เพิ่มเติม",
    call_logs: "บันทึก",
    call_share_screen: "แชร์หน้าจอ",
    call_stop_sharing: "หยุดการแชร์",
    call_end_room: "จบห้อง",
    call_close_logs: "ปิดบันทึก",
    call_controls: "ตัวควบคุมการโทร",
    call_video_call: "วิดีโอคอล",
    call_video_feeds: "ฟีดวิดีโอ",
  },
  ur: {
    landing_secure_video_calls: "محفوظ ویڈیو کالز",
    landing_enter_room: "کمرے میں داخل ہوں",
    landing_join_room_action: "کمرے میں شامل ہوں",
    landing_create_room_action: "کمرہ بنائیں",
    landing_enter_room_code: "کمرے کا کوڈ درج کریں",
    landing_try_again: "دوبارہ کوشش کریں",
    landing_room_code_helper: "جاری رکھنے کے لیے تمام 6 حروف درج کریں۔",
    landing_checking_room: "جانچ ہو رہی ہے…",
    landing_checking_room_hint: "یہ جانچا جا رہا ہے کہ آیا یہ کمرہ پہلے سے فعال ہے۔",
    landing_room_found_hint: "کمرہ مل گیا۔ اب آپ شامل ہو سکتے ہیں۔",
    landing_room_not_found_create_hint: "کمرہ نہیں ملا۔ آپ اسے اسی کوڈ سے بنا سکتے ہیں۔",
    landing_token_required_hint: "یہ کمرے کا کوڈ ابھی استعمال میں نہیں ہے۔",
    landing_enter_token_prompt_action: "کمرے بنانے کے لیے ٹوکن درج کریں",
    landing_enter_token_hint: "نئے کمرے بنانے کے لیے اپنا ٹوکن درج کریں",
    landing_recent: "حالیہ",
    landing_edit_label: "لیبل میں ترمیم کریں",
    landing_delete_room: "کمرہ حذف کریں",
    landing_save_label: "لیبل محفوظ کریں",
    landing_change_token: "ٹوکن تبدیل کریں",
    landing_enter_new_token_placeholder: "نیا ٹوکن درج کریں",
    landing_cancel: "منسوخ",
    landing_save: "محفوظ کریں",
    landing_token_set: "ٹوکن سیٹ ہے",
    landing_host_admin_access_active: "host admin رسائی فعال ہے",
    landing_budget_admin_access_active: "budget admin رسائی فعال ہے",
    landing_change_token_action: "ٹوکن تبدیل کریں",
    landing_clear_token: "ٹوکن صاف کریں",
    landing_created_room: "کمرہ بنا دیا گیا: {roomId}",
    landing_invalid_token: "غلط ٹوکن",
    landing_token_saved: "ٹوکن محفوظ ہو گیا",
    call_room: "کمرہ",
    call_copy_room_code: "کمرے کا کوڈ کاپی کریں",
    call_click_to_copy: "کاپی کرنے کے لیے کلک کریں",
    call_room_code_copied: "کمرے کا کوڈ کاپی ہو گیا",
    call_room_code_copy_failed: "کمرے کا کوڈ کاپی نہ ہو سکا",
    call_desktop_side_by_side: "ساتھ ساتھ",
    call_desktop_focus_remote: "دوسری جانب پر فوکس",
    call_mobile_picture_in_picture: "تصویر میں تصویر",
    call_mobile_remote_only: "صرف دوسری جانب",
    call_you: "آپ",
    call_remote: "دوسری جانب",
    call_muted_badge: "خاموش",
    call_waiting_for_participant: "شریک کا انتظار ہو رہا ہے...",
    call_participant_disconnected: "شریک منقطع ہو گیا",
    call_participant_camera_off: "شریک کا کیمرا بند ہے",
    call_mute: "خاموش کریں",
    call_unmute: "آواز بحال کریں",
    call_camera_on: "کیمرا آن",
    call_camera_off: "کیمرا آف",
    call_leave: "چھوڑیں",
    call_more_actions: "مزید",
    call_logs: "لاگز",
    call_share_screen: "اسکرین شیئر کریں",
    call_stop_sharing: "شیئرنگ بند کریں",
    call_end_room: "کمرہ ختم کریں",
    call_close_logs: "لاگز بند کریں",
    call_controls: "کال کنٹرولز",
    call_video_call: "ویڈیو کال",
    call_video_feeds: "ویڈیو فیڈز",
  },
  fil: {
    landing_secure_video_calls: "Ligtas na mga video call",
    landing_enter_room: "Pumasok sa silid",
    landing_join_room_action: "Sumali sa silid",
    landing_create_room_action: "Gumawa ng silid",
    landing_enter_room_code: "Ilagay ang code ng silid",
    landing_try_again: "Subukan muli",
    landing_room_code_helper: "Ilagay ang lahat ng 6 na titik upang magpatuloy.",
    landing_checking_room: "Sinusuri…",
    landing_checking_room_hint: "Sinusuri kung aktibo na ang silid na ito.",
    landing_room_found_hint: "Nahanap ang silid. Maaari ka nang sumali ngayon.",
    landing_room_not_found_create_hint:
      "Hindi nahanap ang silid. Maaari mo itong gawin gamit ang code na ito.",
    landing_token_required_hint: "Hindi pa ginagamit ang code ng silid na ito.",
    landing_enter_token_prompt_action: "Maglagay ng token para gumawa ng mga silid",
    landing_enter_token_hint: "Ilagay ang iyong token para gumawa ng mga bagong silid",
    landing_recent: "Kamakailan",
    landing_edit_label: "I-edit ang label",
    landing_delete_room: "Tanggalin ang silid",
    landing_save_label: "I-save ang label",
    landing_change_token: "Palitan ang token",
    landing_enter_new_token_placeholder: "Ilagay ang bagong token",
    landing_cancel: "Kanselahin",
    landing_save: "I-save",
    landing_token_set: "Naka-set ang token",
    landing_host_admin_access_active: "aktibo ang access ng host admin",
    landing_budget_admin_access_active: "aktibo ang access ng budget admin",
    landing_change_token_action: "Palitan ang token",
    landing_clear_token: "I-clear ang token",
    landing_created_room: "Nagawa ang silid: {roomId}",
    landing_invalid_token: "Hindi wastong token",
    landing_token_saved: "Na-save ang token",
    call_room: "silid",
    call_copy_room_code: "Kopyahin ang code ng silid",
    call_click_to_copy: "I-click para kopyahin",
    call_room_code_copied: "Nakopya ang code ng silid",
    call_room_code_copy_failed: "Hindi makopya ang code ng silid",
    call_desktop_side_by_side: "Magkatabi",
    call_desktop_focus_remote: "Ituon sa kabila",
    call_mobile_picture_in_picture: "Larawan sa loob ng larawan",
    call_mobile_remote_only: "Kabila lang",
    call_you: "Ikaw",
    call_remote: "Kabila",
    call_muted_badge: "Naka-mute",
    call_waiting_for_participant: "Naghihintay sa kalahok...",
    call_participant_disconnected: "Nadiskonekta ang kalahok",
    call_participant_camera_off: "Naka-off ang camera ng kalahok",
    call_mute: "I-mute",
    call_unmute: "I-unmute",
    call_camera_on: "Buksan ang camera",
    call_camera_off: "Patayin ang camera",
    call_leave: "Umalis",
    call_more_actions: "Higit pa",
    call_logs: "Mga log",
    call_share_screen: "Ibahagi ang screen",
    call_stop_sharing: "Itigil ang pagbabahagi",
    call_end_room: "Tapusin ang silid",
    call_close_logs: "Isara ang mga log",
    call_controls: "Mga kontrol sa tawag",
    call_video_call: "Video call",
    call_video_feeds: "Mga video feed",
  },
  fa: {
    landing_secure_video_calls: "تماس‌های ویدیویی امن",
    landing_enter_room: "ورود به اتاق",
    landing_join_room_action: "پیوستن به اتاق",
    landing_create_room_action: "ایجاد اتاق",
    landing_enter_room_code: "کد اتاق را وارد کنید",
    landing_try_again: "دوباره تلاش کنید",
    landing_room_code_helper: "برای ادامه هر ۶ نویسه را وارد کنید.",
    landing_checking_room: "در حال بررسی…",
    landing_checking_room_hint: "در حال بررسی این هستیم که آیا این اتاق از قبل فعال است یا نه.",
    landing_room_found_hint: "اتاق پیدا شد. اکنون می‌توانید وارد شوید.",
    landing_room_not_found_create_hint: "اتاق پیدا نشد. می‌توانید آن را با این کد ایجاد کنید.",
    landing_token_required_hint: "این کد اتاق هنوز استفاده نشده است.",
    landing_enter_token_prompt_action: "برای ایجاد اتاق توکن وارد کنید",
    landing_enter_token_hint: "برای ایجاد اتاق جدید توکن خود را وارد کنید",
    landing_recent: "اخیر",
    landing_edit_label: "ویرایش برچسب",
    landing_delete_room: "حذف اتاق",
    landing_save_label: "ذخیره برچسب",
    landing_change_token: "تغییر توکن",
    landing_enter_new_token_placeholder: "توکن جدید را وارد کنید",
    landing_cancel: "لغو",
    landing_save: "ذخیره",
    landing_token_set: "توکن تنظیم شده است",
    landing_host_admin_access_active: "دسترسی host admin فعال است",
    landing_budget_admin_access_active: "دسترسی budget admin فعال است",
    landing_change_token_action: "تغییر توکن",
    landing_clear_token: "پاک کردن توکن",
    landing_created_room: "اتاق ایجاد شد: {roomId}",
    landing_invalid_token: "توکن نامعتبر است",
    landing_token_saved: "توکن ذخیره شد",
    call_room: "اتاق",
    call_copy_room_code: "کپی کردن کد اتاق",
    call_click_to_copy: "برای کپی کلیک کنید",
    call_room_code_copied: "کد اتاق کپی شد",
    call_room_code_copy_failed: "کپی کد اتاق ممکن نشد",
    call_desktop_side_by_side: "کنار هم",
    call_desktop_focus_remote: "تمرکز روی طرف مقابل",
    call_mobile_picture_in_picture: "تصویر در تصویر",
    call_mobile_remote_only: "فقط طرف مقابل",
    call_you: "شما",
    call_remote: "طرف مقابل",
    call_muted_badge: "بی‌صدا",
    call_waiting_for_participant: "در انتظار شرکت‌کننده...",
    call_participant_disconnected: "شرکت‌کننده قطع شد",
    call_participant_camera_off: "دوربین شرکت‌کننده خاموش است",
    call_mute: "بی‌صدا کردن",
    call_unmute: "وصل صدا",
    call_camera_on: "روشن کردن دوربین",
    call_camera_off: "خاموش کردن دوربین",
    call_leave: "خروج",
    call_more_actions: "بیشتر",
    call_logs: "گزارش‌ها",
    call_share_screen: "اشتراک‌گذاری صفحه",
    call_stop_sharing: "توقف اشتراک‌گذاری",
    call_end_room: "پایان اتاق",
    call_close_logs: "بستن گزارش‌ها",
    call_controls: "کنترل‌های تماس",
    call_video_call: "تماس ویدیویی",
    call_video_feeds: "جریان‌های ویدیو",
  },
} as const
